import React from "react";
import RegisterComponent from "../../../Components/Auth/Register/RegisterComponent";

const Pages_Register = () => {
  return <RegisterComponent />;
};

export default Pages_Register;
